import { put } from './utils';

const provider = {
    markTeacherBalanceSummaryAsSent: (hash, data) => put(`teacher_balance_summary/${hash}/sent`, data),
};

export default provider;